import { render, staticRenderFns } from "./footer-page.vue?vue&type=template&id=0fa1ee7d&scoped=true"
import script from "./footer-page.vue?vue&type=script&lang=js"
export * from "./footer-page.vue?vue&type=script&lang=js"
import style0 from "./footer-page.vue?vue&type=style&index=0&id=0fa1ee7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1ee7d",
  null
  
)

export default component.exports